import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'VBITLog',
    components: { DialogTemplate },
})
export default class VBITLog extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    news = {}
    newsOrdered: Array<string> = []

    mounted() {
        this.news = this.$i18n.messages[this.$i18n.locale].vbit_log_msg
        this.newsOrdered = Object.keys(this.news).sort().reverse()
    }
}
